import { login, logout, myInfo, punchIn, punchOut, teamById, unbindOpenid } from '@/utils/request'
import { getOpenid, getShopId, getToken, removeOpenid, setOpenid, setShopId, setToken } from '@/utils/cookie'
import { resetRouter } from '@/router'

function getDefaultState () {
  return {
    showReLoginDialog: false,
    token: getToken(),
    shopId: getShopId(),
    workshop: {},
    loaded: false,
    userId: null,
    name: null,
    level: null,
    avatarUrl: null,
    permissions: [],
    punchInTime: null,
    punchOutTime: null,
    positions: [],
    openid: getOpenid(),
    teamId: null,
    team: {},
    technicianType: null,
    punchTimeList: [],
    workScope: []
  }
}

const state = getDefaultState()

// https://blog.csdn.net/Zhooson/article/details/104584802/ 同级调用
const mutations = {
  SET_TOKEN (state, token) {
    state.token = token
    setToken(token)
  },
  SET_SHOP_ID (state, shopId) {
    state.shopId = shopId
    setShopId(shopId)
  },
  SET_PERMISSIONS (state, permissions) {
    state.permissions = permissions || []
    this.commit('menu/UPDATE_BY_PERMISSIONS', permissions)
  },
  SET_OPENID: (state, openid) => {
    state.openid = openid
    if (openid) {
      setOpenid(openid)
    } else {
      removeOpenid()
    }
  },
  ADD_PUNCH (state, punch) {
    if (state.punchTimeList.length === 0) {
      state.punchTimeList.push(punch)
    } else {
      const last = state.punchTimeList[state.punchTimeList.length - 1]
      if (last.punchInTime.split(' ')[0] !== punch.punchInTime.split(' ')[0]) {
        state.punchTimeList.push(punch)
      } else {
        last.punchOutTime = punch.punchOutTime
      }
    }
  },
  RESET (state) {
    Object.assign(state, getDefaultState())

    this.commit('user/SET_TOKEN', null)
    this.commit('user/SET_SHOP_ID', null)
    this.commit('user/SET_OPENID', null)

    this.commit('brand/RESET')
    this.commit('customer/RESET')
    this.commit('data/RESET')
    this.commit('menu/RESET')
    this.commit('model/RESET')
    this.commit('organ/RESET')
    this.commit('procedure/RESET')
    this.commit('shop/RESET')
    this.commit('station/RESET')
    this.commit('team/RESET')
    this.commit('work/RESET')
    this.commit('permission/RESET')
    this.commit('notify/RESET')

    resetRouter()
  }
}

const actions = {
  login ({ commit }, loginRequest) {
    return new Promise((resolve, reject) => {
      login(loginRequest).then(response => {
        commit('SET_TOKEN', response.data)
        if (loginRequest.openid) {
          commit('SET_OPENID', loginRequest.openid)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  myInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      myInfo().then(response => {
        const { user, workshop } = response.data
        state.userId = user.id
        state.userAccount = user.account
        state.name = user.name
        state.level = user.level
        state.punchInTime = user.punchInTime
        state.punchOutTime = user.punchOutTime
        state.workshop = workshop
        state.positions = user.positions
        state.avatarUrl = user.avatarUrl
        state.teamId = user.teamId
        state.technicianType = user.technicianType
        commit('SET_PERMISSIONS', user.permissions)
        this.commit('notify/CONNECT')

        if (user.shopId) {
          commit('SET_SHOP_ID', user.shopId)
          this.dispatch('shop/updateShopInfo')
        }

        if (user.teamId) {
          teamById(user.teamId).then(response => {
            state.team = response.data
          })
        }

        state.loaded = true
        resolve(response.data.user)
      }).catch(error => {
        reject(error)
      })
    })
  },
  reloadMyInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      myInfo().then(response => {
        const { user, workshop } = response.data
        state.workshop = workshop
        state.positions = user.positions
        commit('SET_PERMISSIONS', user.permissions)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  punchIn ({ commit }) {
    return new Promise((resolve, reject) => {
      punchIn().then(response => {
        state.punchInTime = response.data.punchInTime
        commit('ADD_PUNCH', response.data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  punchOut ({ commit }) {
    return new Promise((resolve, reject) => {
      punchOut().then(response => {
        state.punchOutTime = response.data.punchOutTime
        commit('ADD_PUNCH', response.data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('RESET')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  unbind ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      unbindOpenid({
        id: state.userId,
        level: state.level
      }).then(() => {
        dispatch('logout').then(() => {
          window.location.replace('http://' + process.env.VUE_APP_HOST + '/wx/login?reset=true')
          resolve()
        }).catch(error => {
          reject(error)
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
  clearToken ({ commit }) {
    return new Promise(resolve => {
      commit('RESET')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
